var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgCard"},[_c('div',{staticClass:"left"},[_c('p',{staticClass:"t1 __line2"},[_vm._v(_vm._s(_vm.item.title || ''))]),_c('p',{staticClass:"t2 __line2"},[_vm._v(_vm._s(_vm.item.description))])]),_c('div',{staticClass:"right"},[_c('img',{attrs:{"src":_vm.item.banner,"alt":"","srcset":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }